import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private sidebarComponent: any = null;

  constructor() { }

  setSidebarRef(component: any) {
    this.sidebarComponent = component;
  }

  collapseSidebar() {
    if (this.sidebarComponent && !this.sidebarComponent.collapsed) {
      this.sidebarComponent.toggleSidebar();
    }
  }

  expandSidebar() {
    if (this.sidebarComponent && this.sidebarComponent.collapsed) {
      this.sidebarComponent.toggleSidebar();
    }
  }
}
